import React, { useState } from "react";
import axios from "axios";
import { saveTokens } from "../apiAuth";
axios.defaults.withCredentials = true;

const Login = () => {
  const [step, setStep] = useState("password");
  const [email, setEmail] = useState("arysgroom@gmail.com");
  const [password, setPassword] = useState("");
  const [loginId, setLoginId] = useState("");
  const [code, setCode] = useState("");
  const [message, setMessage] = useState("");
  const [saving, setSaving] = useState(false);

  const startLogin = async (event) => {
    event.preventDefault();
    setSaving(true);
    setMessage("");

    try {
      const response = await axios.post(
        "/petgrooming/auth/email-login/start/",
        { email, password }
      );

      setLoginId(response.data.login_id);
      setStep("code");
      setMessage("Code sent. Check the newest email.");
    } catch (error) {
      console.error(error.response?.data || error);
      setMessage(
        error.response?.data?.detail ||
        "Could not send code. Check email and password."
      );
    } finally {
      setSaving(false);
    }
  };

  const verifyCode = async (event) => {
    event.preventDefault();
    setSaving(true);
    setMessage("");

    try {
      const response = await axios.post(
        "/petgrooming/auth/email-login/verify/",
        {
          login_id: loginId,
          code: code.replace(/\D/g, ""),
        }
      );

      saveTokens(response.data);
      window.location.replace("/");
    } catch (error) {
      console.error(error.response?.data || error);
      setMessage(
        error.response?.data?.detail ||
        "Invalid or expired code."
      );
    } finally {
      setSaving(false);
    }
  };

  return (
    <main style={styles.page}>
      <section style={styles.card}>
        <h1 style={styles.title}>Arys Dashboard</h1>

        <p style={styles.subtitle}>
          Login with email, password and email verification code.
        </p>

        {step === "password" && (
          <form onSubmit={startLogin}>
            <label style={styles.label}>
              Email
              <input
                style={styles.input}
                type="email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                required
              />
            </label>

            <label style={styles.label}>
              Password
              <input
                style={styles.input}
                type="password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                required
              />
            </label>

            <button style={styles.button} disabled={saving}>
              {saving ? "Sending..." : "Send verification code"}
            </button>
          </form>
        )}

        {step === "code" && (
          <form onSubmit={verifyCode}>
            <p style={{ marginTop: "14px", color: "#7c6255" }}>Login request ID: {loginId}</p>

            <label style={styles.label}>
              Email code
              <input
                style={{
                  ...styles.input,
                  letterSpacing: "6px",
                  textAlign: "center",
                  fontSize: "22px",
                }}
                type="text"
                value={code}
                onChange={(event) => setCode(event.target.value.replace(/\D/g, ""))}
                maxLength={6}
                required
              />
            </label>

            <button style={styles.button} disabled={saving}>
              {saving ? "Verifying..." : "Verify and login"}
            </button>

            <button
              type="button"
              style={styles.secondaryButton}
              onClick={() => {
                setStep("password");
                setCode("");
                setMessage("");
              }}
            >
              Send another code
            </button>
          </form>
        )}

        {message && <p style={styles.message}>{message}</p>}
      </section>
    </main>
  );
};

const styles = {
  page: {
    minHeight: "100vh",
    background: "#f6eee8",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "24px",
  },
  card: {
    width: "100%",
    maxWidth: "430px",
    background: "#fff",
    borderRadius: "24px",
    padding: "30px",
    boxShadow: "0 20px 60px rgba(0,0,0,0.14)",
  },
  title: {
    margin: 0,
    color: "#4b2e20",
  },
  subtitle: {
    marginTop: "8px",
    color: "#7c6255",
  },
  label: {
    display: "block",
    marginTop: "16px",
    color: "#4b2e20",
    fontWeight: "600",
  },
  input: {
    width: "100%",
    marginTop: "7px",
    padding: "13px",
    borderRadius: "14px",
    border: "1px solid #ddd",
    boxSizing: "border-box",
  },
  button: {
    width: "100%",
    marginTop: "20px",
    padding: "14px",
    border: 0,
    borderRadius: "16px",
    background: "#b8794a",
    color: "#fff",
    fontWeight: "700",
    cursor: "pointer",
  },
  secondaryButton: {
    width: "100%",
    marginTop: "12px",
    padding: "12px",
    borderRadius: "16px",
    border: "1px solid #ddd",
    background: "#fff",
    color: "#4b2e20",
    fontWeight: "700",
    cursor: "pointer",
  },
  message: {
    marginTop: "16px",
    padding: "12px",
    borderRadius: "14px",
    background: "#fff6e8",
    color: "#684225",
  },
};

export default Login;
